import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

export const STAGES = ["NEW LEAD", "CONTACT ATTEMPTED", "CONTACTED", "INFORMATION NEEDED",
  "QUOTE IN PROGRESS", "QUOTE READY", "QUOTE SENT", "FOLLOW-UP", "SOLD / CUSTOMER", "LOST"];

export default function Pipeline() {
  const [leads, setLeads] = useState([]);
  const [dragId, setDragId] = useState(null);
  const nav = useNavigate();

  const load = () => api.get("/leads").then((r) => setLeads(r.data));
  useEffect(() => { load(); }, []);

  const drop = async (stage) => {
    if (!dragId) return;
    const lead = leads.find((l) => l.id === dragId);
    if (lead && lead.status !== stage) {
      setLeads((ls) => ls.map((l) => (l.id === dragId ? { ...l, status: stage } : l)));
      await api.patch(`/leads/${dragId}`, { status: stage });
    }
    setDragId(null);
  };

  return (
    <div className="p-4 sm:p-6">
      <h1 className="font-display text-3xl font-bold mb-1">Sales Pipeline</h1>
      <p className="text-slate-500 mb-6">Drag leads between stages to update their status.</p>
      <div className="flex gap-4 overflow-x-auto pb-4">
        {STAGES.map((stage) => {
          const items = leads.filter((l) => l.status === stage);
          return (
            <div key={stage} onDragOver={(e) => e.preventDefault()} onDrop={() => drop(stage)}
              className="w-72 shrink-0 bg-slate-100 rounded-sm p-3" data-testid={`stage-${stage.replace(/[^a-z]/gi,'-').toLowerCase()}`}>
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-xs uppercase tracking-wider font-bold text-[#0B1E36]">{stage}</h3>
                <span className="font-mono text-xs bg-white rounded-full px-2 py-0.5">{items.length}</span>
              </div>
              <div className="space-y-2 min-h-[40px]">
                {items.map((l) => (
                  <div key={l.id} draggable onDragStart={() => setDragId(l.id)} onClick={() => nav(`/crm/leads/${l.id}`)}
                    className="bg-white border border-slate-200 rounded-sm p-3 cursor-grab active:cursor-grabbing hover:border-[#C5A059] transition-colors" data-testid={`pipeline-card-${l.id}`}>
                    <p className="font-semibold text-sm">{`${l.first_name || ""} ${l.last_name || ""}`.trim() || l.business_name || "Unnamed"}</p>
                    <p className="text-xs text-slate-500 mt-0.5">{(l.insurance_types || []).join(", ") || "General"}</p>
                    <div className="flex items-center justify-between mt-2">
                      <span className="text-[10px] uppercase tracking-wide bg-slate-100 rounded px-1.5 py-0.5">{l.source}</span>
                      {l.incomplete && <span className="text-[10px] text-[#C5A059] font-bold">{l.completion}%</span>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
